import { Component, OnInit } from '@angular/core';
import { SessionService } from '@app/shared/services/session.service';
import { MenuService } from '@app/shared/services/menu.service';
import { TitleService } from '@app/shared/services/title.service';
import { AlertService } from '@app/shared/services/alert.service';
declare var UIkit: any;
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public isResponsiveMenuActive: boolean = false;

  constructor(
    public session: SessionService,
    public menu: MenuService,
    public title: TitleService,
    public alert: AlertService
  ) { }

  ngOnInit() {
  }

  logout() {
    this.session.logout();
  }

  toggleResponsiveMenu() {
    this.isResponsiveMenuActive = !this.isResponsiveMenuActive;
  }

}
